import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { Euler, useLoader, Vector3 } from "@react-three/fiber";
import { useRef } from "react";

type ObstaclesProps = {
    pos?: Vector3,
    euler?: Euler
}


export const Obstacles = (props: ObstaclesProps) => {
    const bridge = useLoader(STLLoader, "/stl/obstacles/bridge.stl");
    const ramp = useLoader(STLLoader, "/stl/obstacles/ramp.stl");

    const ref = useRef();

    return (
        <>
            <group position={props.pos} rotation={props.euler}>
                {/* The bridge. */}
                <mesh ref={ref} position={[0.71, 0, 0]}>
                    <primitive object={bridge} attach="geometry" />
                    <meshStandardMaterial color={[0, 1, 0]} />
                </mesh>

                {/* The ramps. */}
                <mesh ref={ref} position={[0, 0, 0]}>
                    <primitive object={ramp} attach="geometry" />
                    <meshStandardMaterial color={[0, 0, 1]} />
                </mesh>
                <mesh ref={ref} position={[2.12, 0, 0]} rotation={[0, 0, 3.14]}>
                    <primitive object={ramp} attach="geometry" />
                    <meshStandardMaterial color={[1, 1, 0]} />
                </mesh>

            </group>

        </>
    );
};

